<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
// import Area from "@/components/c-input-area";
// import Select from "@/components/c-select";
// import Search from "@/components/c-select-search";
import Loading from "@/components/c-loading";
import { saleService } from "../../../services/saleservice/sale.service";
import { propertylatepaymentService } from "../../../services/propertyservice/propertylatepayment.service";
import i18n from "../../../i18n";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Sale Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    // Area,
    // Select,
    // Search
  },
  watch: {
      valueExtend: function(newVal) { // watch it
        // console.log(newVal);
        let deposit = parseFloat(this.valueBookingAmount);
        let extend = parseFloat(newVal);

        this.valueLastBookingAmount = deposit + extend;
      }
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Booking",
      breadCrumb: {},
      
      sale: {},
      propertySelected: {},
      propertyData: {},
      customeryData: {},
      valueLateDate: this.$moment().clone().format('YYYY-MM-DD'),
      valueStep1: this.$moment().clone().format('YYYY-MM-DD'),
      valueStep2: this.$moment().add(10, 'days').format('YYYY-MM-DD'),
      valueStep3: this.$moment().add(30, 'days').format('YYYY-MM-DD'),
      valueStepFinal: this.$moment().add(40, 'days').format('YYYY-MM-DD'),
      valueSaleId: 0,
      valueSale: '',
      valueProperty: '',
      valuePropertyId: 0,
      valueustomer: '',
      valueCustomerId: 0,
      valueSalePrice: 0

    };
  },
  mounted() {

    this.valuePaymentMethod = 1;

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      saleService.getOne(id)
        .then(response => {

          // console.log(response);

          this.fetchingStats = true;
          if(response.data) {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

            this.sale = response.data;
            this.valueSaleId = this.sale.id;
            this.valueSale = this.sale.code;
            this.valueProperty = this.sale.property;
            this.valuePropertyId = this.sale.property_id;
            this.valueCustomer = `${this.sale.customer} (${this.sale.customer_en})`;
            this.valueCustomerId = this.sale.customer_id;
            this.valueSalePrice = this.sale.sale_price;
            // this.valueFee = this.sale.fee;

            // console.log(this.valuePropertyId);
            
          }

          this.loadingSettings(response.setting);
        
        });
    },

    loadingSettings: function(setting) {

      // this.paymentMethodData = {data: setting.paymentmethods};
      // this.bankAccountData = {data: setting.bankaccounts};
      this.customeryData = {data: setting.customers};
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "booking-list"
          });

        }
      });
    },
    
    submitSave: function() {

      this.tryingToSubmit = true;

      let late_payment = 
      {
        saleId: this.valueSaleId,
        step1: this.valueStep1,
        step2: this.valueStep2,
        step3: this.valueStep3,
        final: this.valueStepFinal,
        lateDate: this.valueLateDate,
        
      };

      let propertyId = this.valuePropertyId;

      // console.log(JSON.stringify(propertyId));

      propertylatepaymentService.insert(late_payment)
        .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {

            if(response.data) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: false,
                confirmButtonColor: "#34c38f",
                confirmButtonText: i18n.t('general.success.yes')
              }).then(result => {
                if (result.value) {

                    this.$router.push(this.$route.query.redirectFrom || {
                      name: "property-view",
                       params: { id: propertyId }
                    });
                } 
              });
            }
          }
        
      });
      
    },

    clearForm: function() {
      this.valueProperty = '';
      this.valuePropertyId = 0;
      this.valueCustomer = '';
      this.valueCustomerId = 0;
      this.valueSalePrice = 0;
      this.valueStep1 = this.$moment().clone().format('YYYY-MM-DD');
      this.valueStep2 = this.$moment().add(10, 'days').format('YYYY-MM-DD');
      this.valueStep3 = this.$moment().add(30, 'days').format('YYYY-MM-DD');
      this.valueStepFinal = this.$moment().add(40, 'days').format('YYYY-MM-DD');
      this.valueLateDate = this.$moment().clone.format('YYYY-MM-DD');


    },
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('sale.list'),
        href: '/general/sale',
      }, {
        text: $t('sale.late-payment'),
        active: true
      }]" :title="$t('sale.late-payment')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('sale.list'),
        href: '/general/sale',
      }, this.breadCrumb]" :title="$t('sale.late-payment')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

              <div class="row">
                <div class="col-md-3">
                  <Input 
                    :type="'text'"
                    :id="'sale_id'"
                    :disabled="true"
                    v-model="valueSale"
                    :label="'sale.text'"
                     /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'text'"
                    :id="'property_id'"
                    :disabled="true"
                    v-model="valueProperty"
                    :label="'property.text'"
                     /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'text'"
                    :id="'from+customer_id'"
                    :disabled="true"
                    v-model="valueCustomer"
                    :label="'customer.text'"
                     /> 
                </div>
                <!-- <div class="col-md-3">
                  <Input 
                    :type="'text'"
                    :id="'saleprice'"
                    :disabled="true"
                    v-model="valueSalePrice"
                    :last="'USD'"
                    :label="'sale.sale-price'"
                     /> 
                </div> -->
                <div class="col-md-3">
                  <Input 
                    :type="'date'"
                    :id="'late_date'"
                    v-model="valueLateDate"
                    :label="'property.late-payment-date'" 
                     /> 
                </div>
                
              </div>
              <div class="row">
                <div class="col-md-3">
                  <Input 
                    :type="'date'"
                    :id="'step_date_1'"
                    v-model="valueStep1"
                    :label="'sale.late-payment-1'" 
                     /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'date'"
                    :id="'step_date_2'"
                    v-model="valueStep2"
                    :label="'sale.late-payment-2'" 
                     /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'date'"
                    :id="'step_date_3'"
                    v-model="valueStep3"
                    :label="'sale.late-payment-3'" 
                     /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'date'"
                    :id="'step_date_final'"
                    v-model="valueStepFinal"
                    :label="'sale.late-payment-final'" 
                     /> 
                </div>
                
              </div>


              <div class="row" style="margin-top: 15px;">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>

    </b-form> 

  </Layout>
</template>